import api from '@/utils/api';
import {
    FETCH_SERVICES,
    FETCH_SERVICE_DETAIL,
    CREATE_SERVICE,
    UPDATE_SERVICE,
    DELETE_SERVICES,
    FETCH_ACTIVE_SERVICES
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Lấy danh sách bản ghi với điều kiện lọc và phân trang.
 * @param {Object} filters Các bộ lọc: { keyword, status, page, per_page }
 */
export const fetchServiceList = (filters) => dispatch => {
    return api.get('/services', { params: filters }).then(res => {
        dispatch({ type: FETCH_SERVICES, payload: res.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách');
        throw err;
    });
};

/**
 * Lấy danh sách bản ghi đang hoạt động (active).
 * @param {Object} filters Các bộ lọc: { keyword, status, page, per_page }
 */
export const fetchActiveServices = (filters = {}) => dispatch => {
    return api.get('/services/active', { params: filters }).then(res => {
        dispatch({ type: FETCH_ACTIVE_SERVICES, payload: res.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể tải danh sách active');
        throw err;
    });
};

/**
 * Lấy chi tiết một bản ghi theo ID.
 * @param {number} id
 */
export const fetchServiceDetail = (id) => dispatch => {
    return api.get(`/services/${id}`).then(res => {
        dispatch({ type: FETCH_SERVICE_DETAIL, payload: res.data.data });
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Không thể lấy chi tiết');
        throw err;
    });
};

/**
 * Tạo mới một bản ghi.
 * @param {Object} data Dữ liệu cần gửi lên server
 */
export const createService = (data) => dispatch => {
    return api.post('/services', data).then(res => {
        dispatch({ type: CREATE_SERVICE, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Tạo thành công');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Tạo thất bại');
        throw err;
    });
};

/**
 * Cập nhật một bản ghi theo ID.
 * @param {number} id
 * @param {Object} data Dữ liệu cập nhật 
 */
export const updateService = (id, data) => dispatch => {
    return api.put(`/services/${id}`, data).then(res => {
        dispatch({ type: UPDATE_SERVICE, payload: res.data.data });
        NotificationManager.success(res.data.msg || 'Cập nhật thành công');
        return res.data.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Cập nhật thất bại');
        throw err;
    });
};

/**
 * Xoá nhiều bản ghi theo danh sách ID.
 * @param {number[]} ids
 */
export const deleteServices = (ids) => dispatch => {
    return api.delete('/services', { data: { ids } }).then(res => {
        dispatch({ type: DELETE_SERVICES, payload: ids });
        NotificationManager.success(res.data.msg || 'Xoá thành công');
        return res.data;
    }).catch(err => {
        NotificationManager.error(err.response?.data?.msg || 'Xoá thất bại');
        throw err;
    });
};
